import { render } from "./PackageCommissionTableField.vue?vue&type=template&id=03ce5a78&scoped=true"
import script from "./PackageCommissionTableField.vue?vue&type=script&lang=js"
export * from "./PackageCommissionTableField.vue?vue&type=script&lang=js"

import "./PackageCommissionTableField.vue?vue&type=style&index=0&id=03ce5a78&scoped=true&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ce5a78"],['__file',"PackageCommissionTableField.vue"]])

export default __exports__